import SearchEvents from "./SearchEvents";
import { ShowResult } from "./Search";
import { AppAction } from "../../root/AppAction";

export interface SearchStore {
    keywords: string[];
    result: ShowResult[];
    isSearching: boolean;
}

const initialStore: SearchStore = {
    keywords: [],
    result: [],
    isSearching: false,
};

export default function video(state: SearchStore = initialStore, action: AppAction) {
    switch (action.type) {
        case SearchEvents.SearchStarted:
            return {
                ...state,
                keyword: action.keywords,
                isSearching: true,
            };

        case SearchEvents.SearchCompleted:
            return {
                ...state,
                result: action.result,
                isSearching: false,
            };

        default:
            return state;
    }
}
